module.exports = __webpack_public_path__ + "static/media/kpi.929c83f1.png";